import React from "react";

/**
 * Simple error boundary that catches rendering errors in its children.
 * It displays a fallback UI instead of a blank/black screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 bg-red-50 border border-red-200 rounded">
          <h2 className="text-lg font-bold text-red-800">Something went wrong.</h2>
          <p className="mt-2 text-sm text-red-700">{this.state.error?.toString()}</p>
        </div>
      );
    }
    return this.props.children;
  }
}

